import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabComponent } from './tab.component';
import { TabContentComponent } from './tab-content/tab-content.component';
import { WmTransitionModule } from '../transition/index';

@NgModule({
	declarations: [TabComponent, TabContentComponent],
	imports: [CommonModule, WmTransitionModule],
	exports: [TabComponent, TabContentComponent]
})
export class WmTabModule {}
